module.exports = __webpack_public_path__ + "static/media/improve_acc_eng_02.a42966da.png";